let IS_PROD = true;
const server = IS_PROD ?
    "https://zoom-meet-c0tq.onrender.com" :

    "http://localhost:8000"


export default server;